// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Pervasives = require("rescript/lib/js/pervasives.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Util$SmartcutsMacros = require("../../../../../bs-utils/src/Util.bs.js");
var CustomMap$SmartcutsMacros = require("../../../CustomMap.bs.js");
var DeccoUtils$SmartcutsMacros = require("../../../../../bs-utils/src/DeccoUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../../../../bs-utils/src/OptionUtils.bs.js");
var StateMachine$SmartcutsMacros = require("../../../StateMachine.bs.js");
var UrlConstraint$SmartcutsMacros = require("../../../UrlConstraint.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("../../../DOM__HtmlElement.bs.js");
var MultiUrlTriggering__Shared$SmartcutsMacros = require("../../../app/MultiUrlTriggering/MultiUrlTriggering__Shared.bs.js");
var DOM__Event__ForSerialization$SmartcutsMacros = require("../../../DOM__Event__ForSerialization.bs.js");
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = require("../../../app/MultiUrlTriggering/MultiUrlTriggering__LinkGroup.bs.js");
var StateMachine__DebounceManager$SmartcutsMacros = require("../../../StateMachine__DebounceManager.bs.js");
var ExtensionMessaging__FromExtension$SmartcutsMacros = require("../../../ExtensionMessaging__FromExtension.bs.js");
var ContentScript__StateMachine__Shared__Types$SmartcutsMacros = require("../ContentScript__StateMachine__Shared__Types.bs.js");

function timeoutId_encode(timeoutId) {
  return timeoutId;
}

function timeoutId_decode(json) {
  return {
          TAG: /* Ok */0,
          _0: json
        };
}

function mode_encode(encoder_htmlElement, encoder_domEvent, v) {
  switch (v.TAG | 0) {
    case /* Init */0 :
        return [
                "Init",
                initializing_encode(encoder_htmlElement, v._0)
              ];
    case /* SelectingUrls */1 :
        return [
                "SelectingUrls",
                selectingUrls_encode(encoder_htmlElement, v._0)
              ];
    case /* AwaitingNewLinks */2 :
        return [
                "AwaitingNewLinks",
                awaitingNewLinks_encode(encoder_htmlElement, v._0)
              ];
    case /* RecordingPageAction */3 :
        return [
                "RecordingPageAction",
                MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_encode(v._0),
                selectingUrls_encode(encoder_htmlElement, v._1)
              ];
    case /* PlayingBackPageAction */4 :
        return [
                "PlayingBackPageAction",
                Decco.intToJson(v._0),
                MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_encode(v._1),
                selectingUrls_encode(encoder_htmlElement, v._2)
              ];
    case /* Exiting */5 :
        return [
                "Exiting",
                exiting_encode(encoder_htmlElement, encoder_domEvent, v._0)
              ];
    case /* Exited */6 :
        return [
                "Exited",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_htmlElement, encoder_domEvent, param);
                      }), v._0)
              ];
    
  }
}

function triggeringElement_encode(encoder_htmlElement, v) {
  if (typeof v === "number") {
    return ["NoTriggeringElement"];
  } else if (v.TAG === /* TriggeringElementAsUrlAndText */0) {
    return [
            "TriggeringElementAsUrlAndText",
            Decco.stringToJson(v._0),
            Decco.optionToJson(Decco.stringToJson, v._1)
          ];
  } else {
    return [
            "TriggeringElementAsHtmlElement",
            Curry._1(encoder_htmlElement, v._0)
          ];
  }
}

function exitReason_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
              }), listener_encode, otherFailureReason_encode, v);
}

function failure_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
              }), listener_encode, otherFailureReason_encode, v);
}

function failure_decode(decoder_htmlElement, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
              }), listener_decode, otherFailureReason_decode, v);
}

function triggeringElement_decode(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NoTriggeringElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoTriggeringElement */0
                  };
          }
      case "TriggeringElementAsHtmlElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TriggeringElementAsHtmlElement */1,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "TriggeringElementAsUrlAndText" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.optionFromJson(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TriggeringElementAsUrlAndText */0,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function exitReason_decode(decoder_htmlElement, decoder_domEvent, v) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
              }), listener_decode, otherFailureReason_decode, v);
}

function event_encode(encoder_htmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* WindowResized */0 :
          return ["WindowResized"];
      case /* DidBgStopRecordPageAction */1 :
          return ["DidBgStopRecordPageAction"];
      case /* PaginationFnCompleted */2 :
          return ["PaginationFnCompleted"];
      case /* PaginationFnFailed */3 :
          return ["PaginationFnFailed"];
      case /* DidDetachListeners */4 :
          return ["DidDetachListeners"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* Initialize */0 :
          return [
                  "Initialize",
                  triggeringElement_encode(encoder_htmlElement, v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1)
                ];
      case /* DidAttachListeners */1 :
          return [
                  "DidAttachListeners",
                  DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
      case /* QuerySelectorAllDidFindElements */2 :
          return [
                  "QuerySelectorAllDidFindElements",
                  Decco.arrayToJson(encoder_htmlElement, v._0)
                ];
      case /* DidFinishGroupLinks */3 :
          return [
                  "DidFinishGroupLinks",
                  Decco.arrayToJson((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                        }), v._0),
                  MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._1)
                ];
      case /* LinkAtIndexUpdated */4 :
          return [
                  "LinkAtIndexUpdated",
                  MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, v._0),
                  Decco.intToJson(v._1)
                ];
      case /* LinksUpdated */5 :
          return [
                  "LinksUpdated",
                  Decco.arrayToJson((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                        }), v._0)
                ];
      case /* DidSetTimer */6 :
          return [
                  "DidSetTimer",
                  v._0
                ];
      case /* TimerFinished */7 :
          return [
                  "TimerFinished",
                  Util$SmartcutsMacros.GlobalTimeoutId.t_encode(v._0),
                  Decco.floatToJson(v._1)
                ];
      case /* PageActionRecordedAsClickElement */8 :
          return [
                  "PageActionRecordedAsClickElement",
                  Curry._1(encoder_htmlElement, v._0)
                ];
      case /* BasicEventWhileUrlTriggering */9 :
          return [
                  "BasicEventWhileUrlTriggering",
                  ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_encode(v._0)
                ];
      case /* DomEvent */10 :
          return [
                  "DomEvent",
                  Curry._1(encoder_domEvent, v._0),
                  Decco.floatToJson(v._1)
                ];
      case /* DidSetNewDebounceTimeout */11 :
          return [
                  "DidSetNewDebounceTimeout",
                  Decco.stringToJson(v._0),
                  DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
      case /* DebounceTimerExpired */12 :
          return [
                  "DebounceTimerExpired",
                  Decco.stringToJson(v._0)
                ];
      case /* DidFlushDebouncedEvent */13 :
          return [
                  "DidFlushDebouncedEvent",
                  StateMachine__DebounceManager$SmartcutsMacros.entry_encode(encoder_domEvent, Decco.unitToJson, v._0)
                ];
      case /* DidClearDebounceTimeout */14 :
          return [
                  "DidClearDebounceTimeout",
                  Decco.stringToJson(v._0)
                ];
      case /* Fail */15 :
          return [
                  "Fail",
                  failure_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      case /* Exit */16 :
          return [
                  "Exit",
                  exitReason_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      
    }
  }
}

var otherFailureReason_encode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_encode;

function state_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Js_dict.fromArray([
              [
                "mode",
                mode_encode(encoder_htmlElement, encoder_domEvent, v.mode)
              ],
              [
                "maybeDebounceManager",
                Decco.optionToJson((function (param) {
                        return StateMachine__DebounceManager$SmartcutsMacros.t_encode(encoder_domEvent, Decco.unitToJson, param);
                      }), v.maybeDebounceManager)
              ]
            ]);
}

function sideEffect_encode(encoder_htmlElement, encoder_domEvent, v) {
  if (typeof v === "number") {
    switch (v) {
      case /* AttachListeners */0 :
          return ["AttachListeners"];
      case /* SetupListenerForClickEvent */1 :
          return ["SetupListenerForClickEvent"];
      case /* HideMarkers */2 :
          return ["HideMarkers"];
      case /* TellBgDidFinishPlaybackPageAction */3 :
          return ["TellBgDidFinishPlaybackPageAction"];
      case /* TellBgMaybeReadyToPlaybackPagination */4 :
          return ["TellBgMaybeReadyToPlaybackPagination"];
      case /* RemoveMarkers */5 :
          return ["RemoveMarkers"];
      case /* RenderPlaybackModal */6 :
          return ["RenderPlaybackModal"];
      case /* RemovePlaybackModal */7 :
          return ["RemovePlaybackModal"];
      
    }
  } else {
    switch (v.TAG | 0) {
      case /* RespondToBg */0 :
          return [
                  "RespondToBg",
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(v._1)
                ];
      case /* Dispatch */1 :
          return [
                  "Dispatch",
                  event_encode(encoder_htmlElement, encoder_domEvent, v._0)
                ];
      case /* QuerySelectorAllForLinks */2 :
          return [
                  "QuerySelectorAllForLinks",
                  Decco.stringToJson(v._0)
                ];
      case /* Timer */3 :
          return [
                  "Timer",
                  Decco.floatToJson(v._0),
                  Decco.intToJson(v._1)
                ];
      case /* AskBgToStopRecordPageAction */4 :
          return [
                  "AskBgToStopRecordPageAction",
                  MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._0)
                ];
      case /* RunPaginateFn */5 :
          return [
                  "RunPaginateFn",
                  MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._0)
                ];
      case /* ScrollToPageClick */6 :
          return [
                  "ScrollToPageClick",
                  MultiUrlTriggering__Shared$SmartcutsMacros.ClickTarget.t_encode(encoder_htmlElement, v._0)
                ];
      case /* RenderMarkers */7 :
          return [
                  "RenderMarkers",
                  Decco.arrayToJson((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                        }), v._0)
                ];
      case /* GroupLinks */8 :
          return [
                  "GroupLinks",
                  Decco.arrayToJson((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                        }), v._0),
                  MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._1),
                  Decco.optionToJson(encoder_htmlElement, v._2)
                ];
      case /* KillTimer */9 :
          return [
                  "KillTimer",
                  v._0
                ];
      case /* TellBgToUpdateLinks */10 :
          return [
                  "TellBgToUpdateLinks",
                  Decco.arrayToJson((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                        }), v._0)
                ];
      case /* TellBgToUpdateLinkAtIndex */11 :
          return [
                  "TellBgToUpdateLinkAtIndex",
                  MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, v._0),
                  Decco.intToJson(v._1)
                ];
      case /* TellBgToUpdateLinkGroups */12 :
          return [
                  "TellBgToUpdateLinkGroups",
                  MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._0)
                ];
      case /* TellBgToUpdatePaginateFn */13 :
          return [
                  "TellBgToUpdatePaginateFn",
                  MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._0)
                ];
      case /* PrepareForScreenshotWithLinksAndRespond */14 :
          return [
                  "PrepareForScreenshotWithLinksAndRespond",
                  Decco.arrayToJson((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                        }), v._0),
                  ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_encode(v._1)
                ];
      case /* ResetDebounceTimeout */15 :
          return [
                  "ResetDebounceTimeout",
                  Decco.stringToJson(v._0),
                  Decco.optionToJson(DeccoUtils$SmartcutsMacros.timeoutId_encode, v._1)
                ];
      case /* ClearDebounceTimeout */16 :
          return [
                  "ClearDebounceTimeout",
                  Decco.stringToJson(v._0),
                  DeccoUtils$SmartcutsMacros.timeoutId_encode(v._1)
                ];
      case /* DetachListeners */17 :
          return [
                  "DetachListeners",
                  DeccoUtils$SmartcutsMacros.unitToUnit_encode(v._0)
                ];
      
    }
  }
}

function listener_encode(v) {
  switch (v) {
    case /* NoListener */0 :
        return ["NoListener"];
    case /* WindowResizedListener */1 :
        return ["WindowResizedListener"];
    case /* MutationObserverListener */2 :
        return ["MutationObserverListener"];
    case /* DOMEventListener */3 :
        return ["DOMEventListener"];
    
  }
}

function initializing_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var maybeDetachListeners = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.unitToUnit_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDetachListeners"), null));
  if (maybeDetachListeners.TAG === /* Ok */0) {
    var triggeringElement = Decco.optionFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeringElement"), null));
    if (triggeringElement.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                maybeDetachListeners: maybeDetachListeners._0,
                triggeringElement: triggeringElement._0
              }
            };
    }
    var e = triggeringElement._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".triggeringElement" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = maybeDetachListeners._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".maybeDetachListeners" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function exiting_decode(decoder_htmlElement, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var didDetachListeners = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didDetachListeners"), null));
  if (didDetachListeners.TAG === /* Ok */0) {
    var nRemainingDebouncedTimeers = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nRemainingDebouncedTimeers"), null));
    if (nRemainingDebouncedTimeers.TAG === /* Ok */0) {
      var allExitReasons = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
              return exitReason_decode(decoder_htmlElement, decoder_domEvent, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "allExitReasons"), null));
      if (allExitReasons.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  didDetachListeners: didDetachListeners._0,
                  nRemainingDebouncedTimeers: nRemainingDebouncedTimeers._0,
                  allExitReasons: allExitReasons._0
                }
              };
      }
      var e = allExitReasons._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".allExitReasons" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = nRemainingDebouncedTimeers._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".nRemainingDebouncedTimeers" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = didDetachListeners._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".didDetachListeners" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function selectingUrls_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var urlPatterns = Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "urlPatterns"), null));
  if (urlPatterns.TAG === /* Ok */0) {
    var page = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page"), null));
    if (page.TAG === /* Ok */0) {
      var links = Decco.arrayFromJson((function (param) {
              return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "links"), null));
      if (links.TAG === /* Ok */0) {
        var linkGroups = CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_decode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "linkGroups"), null));
        if (linkGroups.TAG === /* Ok */0) {
          var detachListeners = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "detachListeners"), null));
          if (detachListeners.TAG === /* Ok */0) {
            var maybePaginateFn = Decco.optionFromJson((function (param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybePaginateFn"), null));
            if (maybePaginateFn.TAG === /* Ok */0) {
              var triggeringLink = Decco.optionFromJson(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "triggeringLink"), null));
              if (triggeringLink.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          urlPatterns: urlPatterns._0,
                          page: page._0,
                          links: links._0,
                          linkGroups: linkGroups._0,
                          detachListeners: detachListeners._0,
                          maybePaginateFn: maybePaginateFn._0,
                          triggeringLink: triggeringLink._0
                        }
                      };
              }
              var e = triggeringLink._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".triggeringLink" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = maybePaginateFn._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".maybePaginateFn" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = detachListeners._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".detachListeners" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = linkGroups._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".linkGroups" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = links._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".links" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = page._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".page" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = urlPatterns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".urlPatterns" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function awaitingNewLinks_decode(decoder_htmlElement, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var page = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "page"), null));
  if (page.TAG === /* Ok */0) {
    var lastUpdatedAt = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "lastUpdatedAt"), null));
    if (lastUpdatedAt.TAG === /* Ok */0) {
      var timeoutId = Decco.optionFromJson(timeoutId_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "timeoutId"), null));
      if (timeoutId.TAG === /* Ok */0) {
        var stateCallback = stateCallback_decode(decoder_htmlElement, Belt_Option.getWithDefault(Js_dict.get(dict$1, "stateCallback"), null));
        if (stateCallback.TAG === /* Ok */0) {
          var didPaginationFnFindNewLinks = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "didPaginationFnFindNewLinks"), null));
          if (didPaginationFnFindNewLinks.TAG === /* Ok */0) {
            var maybeLimitToSingleGroup = Decco.optionFromJson((function (json) {
                    var match = Js_json.classify(json);
                    if (typeof match === "number") {
                      return Decco.error(undefined, "Not a tuple", json);
                    }
                    if (match.TAG !== /* JSONArray */3) {
                      return Decco.error(undefined, "Not a tuple", json);
                    }
                    var match$1 = match._0;
                    if (match$1.length !== 2) {
                      return Decco.error(undefined, "Incorrect cardinality", json);
                    }
                    var v0 = match$1[0];
                    var v1 = match$1[1];
                    var match$2 = Decco.stringFromJson(v0);
                    var match$3 = MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode(v1);
                    if (match$2.TAG === /* Ok */0) {
                      if (match$3.TAG === /* Ok */0) {
                        return {
                                TAG: /* Ok */0,
                                _0: [
                                  match$2._0,
                                  match$3._0
                                ]
                              };
                      }
                      var e = match$3._0;
                      return {
                              TAG: /* Error */1,
                              _0: {
                                path: "[1]" + e.path,
                                message: e.message,
                                value: e.value
                              }
                            };
                    }
                    var e$1 = match$2._0;
                    return {
                            TAG: /* Error */1,
                            _0: {
                              path: "[0]" + e$1.path,
                              message: e$1.message,
                              value: e$1.value
                            }
                          };
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeLimitToSingleGroup"), null));
            if (maybeLimitToSingleGroup.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        page: page._0,
                        lastUpdatedAt: lastUpdatedAt._0,
                        timeoutId: timeoutId._0,
                        stateCallback: stateCallback._0,
                        didPaginationFnFindNewLinks: didPaginationFnFindNewLinks._0,
                        maybeLimitToSingleGroup: maybeLimitToSingleGroup._0
                      }
                    };
            }
            var e = maybeLimitToSingleGroup._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".maybeLimitToSingleGroup" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = didPaginationFnFindNewLinks._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".didPaginationFnFindNewLinks" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = stateCallback._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".stateCallback" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = timeoutId._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".timeoutId" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = lastUpdatedAt._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".lastUpdatedAt" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  var e$5 = page._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".page" + e$5.path,
            message: e$5.message,
            value: e$5.value
          }
        };
}

function stateCallback_encode(encoder_htmlElement, v) {
  if (v.TAG === /* Cb_SelectingUrls */0) {
    return [
            "Cb_SelectingUrls",
            selectingUrls_encode(encoder_htmlElement, v._0)
          ];
  } else {
    return [
            "Cb_PlayingBackPageAction",
            MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_encode(v._0),
            MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, v._1),
            selectingUrls_encode(encoder_htmlElement, v._2)
          ];
  }
}

function state_decode(decoder_htmlElement, decoder_domEvent, v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var mode = mode_decode(decoder_htmlElement, decoder_domEvent, Belt_Option.getWithDefault(Js_dict.get(dict$1, "mode"), null));
  if (mode.TAG === /* Ok */0) {
    var maybeDebounceManager = Decco.optionFromJson((function (param) {
            return StateMachine__DebounceManager$SmartcutsMacros.t_decode(decoder_domEvent, Decco.unitFromJson, param);
          }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeDebounceManager"), null));
    if (maybeDebounceManager.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                mode: mode._0,
                maybeDebounceManager: maybeDebounceManager._0
              }
            };
    }
    var e = maybeDebounceManager._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".maybeDebounceManager" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = mode._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".mode" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function sideEffect_decode(decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AskBgToStopRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AskBgToStopRecordPageAction */4,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "AttachListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* AttachListeners */0
                  };
          }
      case "ClearDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ClearDebounceTimeout */16,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DetachListeners" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DetachListeners */17,
                      _0: v0$1._0
                    }
                  };
          }
          var e$3 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Dispatch" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = event_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Dispatch */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$4 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "GroupLinks" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$5 = Decco.optionFromJson(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              if (match$5.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* GroupLinks */8,
                          _0: match$3._0,
                          _1: match$4._0,
                          _2: match$5._0
                        }
                      };
              }
              var e$5 = match$5._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$5.path,
                        message: e$5.message,
                        value: e$5.value
                      }
                    };
            }
            var e$6 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "HideMarkers" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* HideMarkers */2
                  };
          }
      case "KillTimer" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = {
            TAG: /* Ok */0,
            _0: Belt_Array.getExn(jsonArr$1, 1)
          };
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* KillTimer */9,
                      _0: v0$3._0
                    }
                  };
          }
          var e$8 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "PrepareForScreenshotWithLinksAndRespond" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$6 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          var match$7 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$6.TAG === /* Ok */0) {
            if (match$7.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* PrepareForScreenshotWithLinksAndRespond */14,
                        _0: match$6._0,
                        _1: match$7._0
                      }
                    };
            }
            var e$9 = match$7._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$9.path,
                      message: e$9.message,
                      value: e$9.value
                    }
                  };
          }
          var e$10 = match$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "QuerySelectorAllForLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* QuerySelectorAllForLinks */2,
                      _0: v0$4._0
                    }
                  };
          }
          var e$11 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "RemoveMarkers" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemoveMarkers */5
                  };
          }
      case "RemovePlaybackModal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemovePlaybackModal */7
                  };
          }
      case "RenderMarkers" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RenderMarkers */7,
                      _0: v0$5._0
                    }
                  };
          }
          var e$12 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "RenderPlaybackModal" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderPlaybackModal */6
                  };
          }
      case "ResetDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$9 = Decco.optionFromJson(DeccoUtils$SmartcutsMacros.timeoutId_decode, Belt_Array.getExn(jsonArr$1, 2));
          if (match$8.TAG === /* Ok */0) {
            if (match$9.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ResetDebounceTimeout */15,
                        _0: match$8._0,
                        _1: match$9._0
                      }
                    };
            }
            var e$13 = match$9._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$13.path,
                      message: e$13.message,
                      value: e$13.value
                    }
                  };
          }
          var e$14 = match$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "RespondToBg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$10 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$11 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$10.TAG === /* Ok */0) {
            if (match$11.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RespondToBg */0,
                        _0: match$10._0,
                        _1: match$11._0
                      }
                    };
            }
            var e$15 = match$11._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$15.path,
                      message: e$15.message,
                      value: e$15.value
                    }
                  };
          }
          var e$16 = match$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "RunPaginateFn" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* RunPaginateFn */5,
                      _0: v0$6._0
                    }
                  };
          }
          var e$17 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "ScrollToPageClick" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = MultiUrlTriggering__Shared$SmartcutsMacros.ClickTarget.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ScrollToPageClick */6,
                      _0: v0$7._0
                    }
                  };
          }
          var e$18 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "SetupListenerForClickEvent" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* SetupListenerForClickEvent */1
                  };
          }
      case "TellBgDidFinishPlaybackPageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TellBgDidFinishPlaybackPageAction */3
                  };
          }
      case "TellBgMaybeReadyToPlaybackPagination" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TellBgMaybeReadyToPlaybackPagination */4
                  };
          }
      case "TellBgToUpdateLinkAtIndex" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$12 = MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$13 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$12.TAG === /* Ok */0) {
            if (match$13.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TellBgToUpdateLinkAtIndex */11,
                        _0: match$12._0,
                        _1: match$13._0
                      }
                    };
            }
            var e$19 = match$13._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$19.path,
                      message: e$19.message,
                      value: e$19.value
                    }
                  };
          }
          var e$20 = match$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "TellBgToUpdateLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TellBgToUpdateLinkGroups */12,
                      _0: v0$8._0
                    }
                  };
          }
          var e$21 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "TellBgToUpdateLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TellBgToUpdateLinks */10,
                      _0: v0$9._0
                    }
                  };
          }
          var e$22 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "TellBgToUpdatePaginateFn" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TellBgToUpdatePaginateFn */13,
                      _0: v0$10._0
                    }
                  };
          }
          var e$23 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "Timer" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$14 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$15 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$14.TAG === /* Ok */0) {
            if (match$15.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Timer */3,
                        _0: match$14._0,
                        _1: match$15._0
                      }
                    };
            }
            var e$24 = match$15._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$24.path,
                      message: e$24.message,
                      value: e$24.value
                    }
                  };
          }
          var e$25 = match$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function event_decode(decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "BasicEventWhileUrlTriggering" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.basicEvent_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* BasicEventWhileUrlTriggering */9,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "DebounceTimerExpired" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DebounceTimerExpired */12,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "DidAttachListeners" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = DeccoUtils$SmartcutsMacros.unitToUnit_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidAttachListeners */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "DidBgStopRecordPageAction" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidBgStopRecordPageAction */1
                  };
          }
      case "DidClearDebounceTimeout" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidClearDebounceTimeout */14,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "DidDetachListeners" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidDetachListeners */4
                  };
          }
      case "DidFinishGroupLinks" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DidFinishGroupLinks */3,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e$4 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "DidFlushDebouncedEvent" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = StateMachine__DebounceManager$SmartcutsMacros.entry_decode(decoder_domEvent, Decco.unitFromJson, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidFlushDebouncedEvent */13,
                      _0: v0$4._0
                    }
                  };
          }
          var e$6 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "DidSetNewDebounceTimeout" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = DeccoUtils$SmartcutsMacros.timeoutId_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DidSetNewDebounceTimeout */11,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$7 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "DidSetTimer" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = {
            TAG: /* Ok */0,
            _0: Belt_Array.getExn(jsonArr$1, 1)
          };
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* DidSetTimer */6,
                      _0: v0$5._0
                    }
                  };
          }
          var e$9 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "DomEvent" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Curry._1(decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* DomEvent */10,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$10 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = exitReason_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exit */16,
                      _0: v0$6._0
                    }
                  };
          }
          var e$12 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "Fail" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = failure_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Fail */15,
                      _0: v0$7._0
                    }
                  };
          }
          var e$13 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "Initialize" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = triggeringElement_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = ExtensionMessaging__FromExtension$SmartcutsMacros.All.respondToSender_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* Initialize */0,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$14 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$14.path,
                      message: e$14.message,
                      value: e$14.value
                    }
                  };
          }
          var e$15 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "LinkAtIndexUpdated" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* LinkAtIndexUpdated */4,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$16 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "LinksUpdated" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(decoder_htmlElement, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* LinksUpdated */5,
                      _0: v0$8._0
                    }
                  };
          }
          var e$18 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "PageActionRecordedAsClickElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = Curry._1(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* PageActionRecordedAsClickElement */8,
                      _0: v0$9._0
                    }
                  };
          }
          var e$19 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "PaginationFnCompleted" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PaginationFnCompleted */2
                  };
          }
      case "PaginationFnFailed" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* PaginationFnFailed */3
                  };
          }
      case "QuerySelectorAllDidFindElements" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = Decco.arrayFromJson(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* QuerySelectorAllDidFindElements */2,
                      _0: v0$10._0
                    }
                  };
          }
          var e$20 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "TimerFinished" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$11 = Util$SmartcutsMacros.GlobalTimeoutId.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$12 = Decco.floatFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$11.TAG === /* Ok */0) {
            if (match$12.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TimerFinished */7,
                        _0: match$11._0,
                        _1: match$12._0
                      }
                    };
            }
            var e$21 = match$12._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$21.path,
                      message: e$21.message,
                      value: e$21.value
                    }
                  };
          }
          var e$22 = match$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "WindowResized" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* WindowResized */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function listener_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DOMEventListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DOMEventListener */3
                  };
          }
      case "MutationObserverListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* MutationObserverListener */2
                  };
          }
      case "NoListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoListener */0
                  };
          }
      case "WindowResizedListener" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* WindowResizedListener */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var otherFailureReason_decode = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.otherFailureReason_decode;

function initializing_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "maybeDetachListeners",
                Decco.optionToJson(DeccoUtils$SmartcutsMacros.unitToUnit_encode, v.maybeDetachListeners)
              ],
              [
                "triggeringElement",
                Decco.optionToJson(encoder_htmlElement, v.triggeringElement)
              ]
            ]);
}

function selectingUrls_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "urlPatterns",
                Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v.urlPatterns)
              ],
              [
                "page",
                Decco.intToJson(v.page)
              ],
              [
                "links",
                Decco.arrayToJson((function (param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(encoder_htmlElement, param);
                      }), v.links)
              ],
              [
                "linkGroups",
                CustomMap$SmartcutsMacros.MapStringWithDeccoSupport.t_encode(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v.linkGroups)
              ],
              [
                "detachListeners",
                DeccoUtils$SmartcutsMacros.unitToUnit_encode(v.detachListeners)
              ],
              [
                "maybePaginateFn",
                Decco.optionToJson((function (param) {
                        return MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_encode(encoder_htmlElement, param);
                      }), v.maybePaginateFn)
              ],
              [
                "triggeringLink",
                Decco.optionToJson(encoder_htmlElement, v.triggeringLink)
              ]
            ]);
}

function awaitingNewLinks_encode(encoder_htmlElement, v) {
  return Js_dict.fromArray([
              [
                "page",
                Decco.intToJson(v.page)
              ],
              [
                "lastUpdatedAt",
                Decco.optionToJson(Decco.floatToJson, v.lastUpdatedAt)
              ],
              [
                "timeoutId",
                Decco.optionToJson(timeoutId_encode, v.timeoutId)
              ],
              [
                "stateCallback",
                stateCallback_encode(encoder_htmlElement, v.stateCallback)
              ],
              [
                "didPaginationFnFindNewLinks",
                Decco.boolToJson(v.didPaginationFnFindNewLinks)
              ],
              [
                "maybeLimitToSingleGroup",
                Decco.optionToJson((function (param) {
                        return [
                                Decco.stringToJson(param[0]),
                                MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode(param[1])
                              ];
                      }), v.maybeLimitToSingleGroup)
              ]
            ]);
}

function exiting_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Js_dict.fromArray([
              [
                "didDetachListeners",
                Decco.boolToJson(v.didDetachListeners)
              ],
              [
                "nRemainingDebouncedTimeers",
                Decco.intToJson(v.nRemainingDebouncedTimeers)
              ],
              [
                "allExitReasons",
                Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_encode, (function (param) {
                        return exitReason_encode(encoder_htmlElement, encoder_domEvent, param);
                      }), v.allExitReasons)
              ]
            ]);
}

function mode_decode(decoder_htmlElement, decoder_domEvent, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "AwaitingNewLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = awaitingNewLinks_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* AwaitingNewLinks */2,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Exited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.t_decode, (function (param) {
                  return exitReason_decode(decoder_htmlElement, decoder_domEvent, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exited */6,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Exiting" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = exiting_decode(decoder_htmlElement, decoder_domEvent, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Exiting */5,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Init" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = initializing_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Init */0,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "PlayingBackPageAction" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_decode(Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* PlayingBackPageAction */4,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e$4 = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e$4.path,
                        message: e$4.message,
                        value: e$4.value
                      }
                    };
            }
            var e$5 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$5.path,
                      message: e$5.message,
                      value: e$5.value
                    }
                  };
          }
          var e$6 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "RecordingPageAction" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$4 = MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$5 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
          if (match$4.TAG === /* Ok */0) {
            if (match$5.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* RecordingPageAction */3,
                        _0: match$4._0,
                        _1: match$5._0
                      }
                    };
            }
            var e$7 = match$5._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$7.path,
                      message: e$7.message,
                      value: e$7.value
                    }
                  };
          }
          var e$8 = match$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "SelectingUrls" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* SelectingUrls */1,
                      _0: v0$4._0
                    }
                  };
          }
          var e$9 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stateCallback_decode(decoder_htmlElement, v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Cb_PlayingBackPageAction" :
          if (tagged.length !== 4) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = MultiUrlTriggering__Shared$SmartcutsMacros.remainingPages_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.t_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 2));
          var match$3 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 3));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              if (match$3.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          TAG: /* Cb_PlayingBackPageAction */1,
                          _0: match$1._0,
                          _1: match$2._0,
                          _2: match$3._0
                        }
                      };
              }
              var e = match$3._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: "[2]" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Cb_SelectingUrls" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = selectingUrls_decode(decoder_htmlElement, Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Cb_SelectingUrls */0,
                      _0: v0._0
                    }
                  };
          }
          var e$3 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function errorContext_encode(encoder_htmlElement, encoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_encode, (function (param) {
                return state_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return event_encode(encoder_htmlElement, encoder_domEvent, param);
              }), (function (param) {
                return sideEffect_encode(encoder_htmlElement, encoder_domEvent, param);
              }), listener_encode, v);
}

function errorContext_decode(decoder_htmlElement, decoder_domEvent, v) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.ErrorContext.WithListener.t_decode, (function (param) {
                return state_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return event_decode(decoder_htmlElement, decoder_domEvent, param);
              }), (function (param) {
                return sideEffect_decode(decoder_htmlElement, decoder_domEvent, param);
              }), listener_decode, v);
}

function stringifyListener(v) {
  switch (v) {
    case /* NoListener */0 :
        return "NoListener";
    case /* WindowResizedListener */1 :
        return "WindowResizedListener";
    case /* MutationObserverListener */2 :
        return "MutationObserverListener";
    case /* DOMEventListener */3 :
        return "DOMEventListener";
    
  }
}

function stringifyStateCallback(v) {
  if (v.TAG === /* Cb_SelectingUrls */0) {
    return "Cb_SelectingUrls(selectingUrls)";
  } else {
    return "Cb_PlayingBackPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.stringifyRemainingPages(v._0) + ", paginateFn, selectingUrls)");
  }
}

function stringifyTriggeringElement(stringifyHtmlElement, triggeringElement) {
  if (typeof triggeringElement === "number") {
    return "NoTriggeringElement";
  } else if (triggeringElement.TAG === /* TriggeringElementAsUrlAndText */0) {
    return "TriggeringElementAsUrlAndText(" + (triggeringElement._0 + (". " + (OptionUtils$SmartcutsMacros.withDefault("None", triggeringElement._1) + ")")));
  } else {
    return "TriggeringElementAsHtmlElement(" + (Curry._1(stringifyHtmlElement, triggeringElement._0) + ")");
  }
}

function stringifyInitializing(stringifyHtmlElement, param) {
  var arg = OptionUtils$SmartcutsMacros.map(param.triggeringElement, stringifyHtmlElement);
  return "{triggeringElement: " + ((function (param) {
                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
              })("None") + "}");
}

function stringifyMode(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, state) {
  switch (state.TAG | 0) {
    case /* Init */0 :
        return "Init(" + (stringifyInitializing(stringifyHtmlElement, state._0) + ")");
    case /* SelectingUrls */1 :
        var match = state._0;
        return "SelectingUrls({ page: " + (String(match.page) + (", urlPatten, links: array(length=" + (String(match.links.length) + ("), linkGroups({len: " + (String(MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.size(match.linkGroups)) + "})})")))));
    case /* AwaitingNewLinks */2 :
        var match$1 = state._0;
        var lastUpdatedAt = match$1.lastUpdatedAt;
        var tmp;
        if (lastUpdatedAt !== undefined) {
          var ms = Date.now() - lastUpdatedAt;
          tmp = "last updated " + ((ms / 1000.0).toString() + "s ago");
        } else {
          tmp = "not updated yet";
        }
        var arg = OptionUtils$SmartcutsMacros.map(match$1.timeoutId, (function (id) {
                return String(id);
              }));
        return "AwaitingNewLinks({page: " + (String(match$1.page) + (", lastUpdated: " + (tmp + (", timeoutId: " + ((function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })("None") + (", stateCallback: " + (stringifyStateCallback(match$1.stateCallback) + "})")))))));
    case /* RecordingPageAction */3 :
        var match$2 = state._1;
        return "RecordingPageAction(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Step.stringifyPageAction(state._0) + (", { page: " + (String(match$2.page) + (", urlPatten, links: array(length=" + (String(match$2.links.length) + ") })")))));
    case /* PlayingBackPageAction */4 :
        return "PlayingBackPageAction(page=" + (String(state._0) + (", remaining=" + (MultiUrlTriggering__Shared$SmartcutsMacros.stringifyRemainingPages(state._1) + (", {  urlPatten, links: array(length=" + (String(state._2.links.length) + ") })")))));
    case /* Exiting */5 :
        var match$3 = state._0;
        return "Exiting({ allExitReasons: " + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                        return stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
                      }), match$3.allExitReasons) + (", nRemainingDebouncedTimeers: " + (String(match$3.nRemainingDebouncedTimeers) + (", didDetachListeners: " + (Pervasives.string_of_bool(match$3.didDetachListeners) + " })")))));
    case /* Exited */6 :
        return "Exited(" + (Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.stringify, (function (param) {
                        return stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
                      }), state._0) + ")");
    
  }
}

function stringifyState(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param) {
  var mode = param.mode;
  var func = function (param, param$1, param$2) {
    return stringifyMode(stringifyHtmlElement, param, param$1, param$2);
  };
  var func$1 = Curry._1(func, stringifyDomEvent);
  return "{ mode: " + (Curry._1((function (param) {
                  return Curry._2(func$1, param, mode);
                }), stringifyBasicEvent) + ("maybeDebounceManager: " + (OptionUtils$SmartcutsMacros.stringify((function (param) {
                      return "debounceManager";
                    }), param.maybeDebounceManager) + "}")));
}

function stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, $$event) {
  if (typeof $$event === "number") {
    switch ($$event) {
      case /* WindowResized */0 :
          return "WindowResized";
      case /* DidBgStopRecordPageAction */1 :
          return "DidBgStopRecordPageAction";
      case /* PaginationFnCompleted */2 :
          return "PaginationFnCompleted";
      case /* PaginationFnFailed */3 :
          return "PaginationFnFailed";
      case /* DidDetachListeners */4 :
          return "DidDetachListeners";
      
    }
  } else {
    switch ($$event.TAG | 0) {
      case /* Initialize */0 :
          return "Initialize(triggeringElement, respondToBg)";
      case /* DidAttachListeners */1 :
          return "DidAttachListeners(callback)";
      case /* QuerySelectorAllDidFindElements */2 :
          return "QuerySelectorAllDidFindElements(htmlElements({len: " + (String($$event._0.length) + "}))");
      case /* DidFinishGroupLinks */3 :
          return "DidFinishGroupLinks(array(length=" + (String($$event._0.length) + ("), linkGroups(size=" + (String(Belt_MapString.size($$event._1)) + "))")));
      case /* LinkAtIndexUpdated */4 :
          return "LinkAtIndexUpdated(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Link.stringify(stringifyHtmlElement, $$event._0) + (", " + (String($$event._1) + ")")));
      case /* LinksUpdated */5 :
          return "LinksUpdated(array(length=" + (String($$event._0.length) + "))");
      case /* DidSetTimer */6 :
          return "DidSetTimer(" + (String($$event._0) + ")");
      case /* TimerFinished */7 :
          var ms = Date.now() - $$event._1;
          return "TimerFinished(" + (String($$event._0) + (", started " + ((ms / 1000.0).toString() + "s ago)")));
      case /* PageActionRecordedAsClickElement */8 :
          return "PageActionRecordedAsClickElement(element)";
      case /* BasicEventWhileUrlTriggering */9 :
          return "BasicEventWhileUrlTriggering(" + (Curry._1(stringifyBasicEvent, $$event._0) + ")");
      case /* DomEvent */10 :
          return "DomEvent(" + (Curry._1(stringifyDomEvent, $$event._0) + (", " + ($$event._1.toString() + ")")));
      case /* DidSetNewDebounceTimeout */11 :
          return "DidSetNewDebounceTimeout(" + ($$event._0 + ", timeoutId)");
      case /* DebounceTimerExpired */12 :
          return "DebounceTimerExpired(" + ($$event._0 + ")");
      case /* DidFlushDebouncedEvent */13 :
          return "DidFlushDebouncedEvent(entry)";
      case /* DidClearDebounceTimeout */14 :
          return "DidClearDebounceTimeout(" + ($$event._0 + ")");
      case /* Fail */15 :
          return "Fail(" + (stringifyFailure(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, $$event._0) + ")");
      case /* Exit */16 :
          return "Exit(" + (stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, $$event._0) + ")");
      
    }
  }
}

function stringifyFailure(stringifyHtmlElement, stringifyBasicEvent, stringifyDomEvent, failure) {
  return Curry._6(StateMachine$SmartcutsMacros.Failure.WithListener.stringify, (function (param) {
                return stringifyState(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
              }), (function (param) {
                return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
              }), (function (param) {
                return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
              }), stringifyListener, stringifyOtherFailureReason, failure);
}

function stringifyExitReason(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, exitReason) {
  return Curry._6(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.stringify, (function (param) {
                return stringifyState(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
              }), (function (param) {
                return stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
              }), (function (param) {
                return stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, param);
              }), stringifyListener, stringifyOtherFailureReason, exitReason);
}

function stringifySideEffect(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* AttachListeners */0 :
          return "AttachListeners";
      case /* SetupListenerForClickEvent */1 :
          return "SetupListenerForClickEvent";
      case /* HideMarkers */2 :
          return "HideMarkers";
      case /* TellBgDidFinishPlaybackPageAction */3 :
          return "TellBgDidFinishPlaybackPageAction";
      case /* TellBgMaybeReadyToPlaybackPagination */4 :
          return "TellBgMaybeReadyToPlaybackPagination";
      case /* RemoveMarkers */5 :
          return "RemoveMarkers";
      case /* RenderPlaybackModal */6 :
          return "RenderPlaybackModal";
      case /* RemovePlaybackModal */7 :
          return "RemovePlaybackModal";
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* RespondToBg */0 :
          return "RespondToBg(respondToBg, " + (JSON.stringify(ExtensionMessaging__FromExtension$SmartcutsMacros.All.response_encode(sideEffect._1)) + ")");
      case /* Dispatch */1 :
          return "Dispatch(" + (stringifyEvent(stringifyHtmlElement, stringifyDomEvent, stringifyBasicEvent, sideEffect._0) + ")");
      case /* QuerySelectorAllForLinks */2 :
          return "QuerySelectorAllForLinks(" + (sideEffect._0 + ")");
      case /* Timer */3 :
          var ms = Date.now() - sideEffect._0;
          return "Timer(started " + ((ms / 1000.0).toString() + ("s ago, waitForMillis=" + (String(sideEffect._1) + ")")));
      case /* AskBgToStopRecordPageAction */4 :
          return "AskBgToStopRecordPageAction(paginateFn)";
      case /* RunPaginateFn */5 :
          return "RunPaginateFn(" + (MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.stringify(sideEffect._0) + ")");
      case /* ScrollToPageClick */6 :
          return "ScrollToPageClick(selector)";
      case /* RenderMarkers */7 :
          return "RenderMarkers(array(length=" + (String(sideEffect._0.length) + "))");
      case /* GroupLinks */8 :
          var arg = OptionUtils$SmartcutsMacros.map(sideEffect._2, stringifyHtmlElement);
          return "GroupLinks(array(length=" + (String(sideEffect._0.length) + ("), linkGroups(size=" + (String(Belt_MapString.size(sideEffect._1)) + ("), " + ((function (param) {
                                return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                              })("None") + ")")))));
      case /* KillTimer */9 :
          return "KillTimer(" + (String(sideEffect._0) + ")");
      case /* TellBgToUpdateLinks */10 :
          return "TellBgToUpdateLinks(array(length=" + (String(sideEffect._0.length) + "))");
      case /* TellBgToUpdateLinkAtIndex */11 :
          return "TellBgToUpdateLinkAtIndex(" + (MultiUrlTriggering__Shared$SmartcutsMacros.Link.stringify(stringifyHtmlElement, sideEffect._0) + (", " + (String(sideEffect._1) + ")")));
      case /* TellBgToUpdateLinkGroups */12 :
          return "TellBgToUpdateLinkGroups(linkGroups(size=" + (String(Belt_MapString.size(sideEffect._0)) + "))");
      case /* TellBgToUpdatePaginateFn */13 :
          return "TellBgToUpdatePaginateFn(" + (MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.stringify(sideEffect._0) + ")");
      case /* PrepareForScreenshotWithLinksAndRespond */14 :
          return "PrepareForScreenshotWithLinksAndRespond(links=array(length=" + (String(sideEffect._0.length) + "), respondToBg)");
      case /* ResetDebounceTimeout */15 :
          return "ResetDebounceTimeout(" + (sideEffect._0 + (", maybePreviouseTimeoutId=" + OptionUtils$SmartcutsMacros.stringify((function (param) {
                            return "timeoutId";
                          }), sideEffect._1)));
      case /* ClearDebounceTimeout */16 :
          return "ClearDebounceTimeout(" + (sideEffect._0 + ", timeoutId)");
      case /* DetachListeners */17 :
          return "DetachListeners(fn)";
      
    }
  }
}

var stringifyOtherFailureReason = ContentScript__StateMachine__Shared__Types$SmartcutsMacros.stringifyOtherFailureReason;

function mapTriggeringElement(mapHtmlElement, triggeringElement) {
  if (typeof triggeringElement === "number") {
    return /* NoTriggeringElement */0;
  } else if (triggeringElement.TAG === /* TriggeringElementAsUrlAndText */0) {
    return {
            TAG: /* TriggeringElementAsUrlAndText */0,
            _0: triggeringElement._0,
            _1: triggeringElement._1
          };
  } else {
    return {
            TAG: /* TriggeringElementAsHtmlElement */1,
            _0: Curry._1(mapHtmlElement, triggeringElement._0)
          };
  }
}

function mapInitializing(mapHtmlElement, initializing) {
  return {
          maybeDetachListeners: initializing.maybeDetachListeners,
          triggeringElement: OptionUtils$SmartcutsMacros.map(initializing.triggeringElement, mapHtmlElement)
        };
}

function mapState(mapHtmlElement, mapDomEvent, param) {
  var mode = param.mode;
  var tmp;
  switch (mode.TAG | 0) {
    case /* Init */0 :
        tmp = {
          TAG: /* Init */0,
          _0: mapInitializing(mapHtmlElement, mode._0)
        };
        break;
    case /* SelectingUrls */1 :
        tmp = {
          TAG: /* SelectingUrls */1,
          _0: mapSelectingUrls(mapHtmlElement, mode._0)
        };
        break;
    case /* AwaitingNewLinks */2 :
        var match = mode._0;
        tmp = {
          TAG: /* AwaitingNewLinks */2,
          _0: {
            page: match.page,
            lastUpdatedAt: match.lastUpdatedAt,
            timeoutId: match.timeoutId,
            stateCallback: mapStateCallback(mapHtmlElement, match.stateCallback),
            didPaginationFnFindNewLinks: match.didPaginationFnFindNewLinks,
            maybeLimitToSingleGroup: match.maybeLimitToSingleGroup
          }
        };
        break;
    case /* RecordingPageAction */3 :
        tmp = {
          TAG: /* RecordingPageAction */3,
          _0: mode._0,
          _1: mapSelectingUrls(mapHtmlElement, mode._1)
        };
        break;
    case /* PlayingBackPageAction */4 :
        tmp = {
          TAG: /* PlayingBackPageAction */4,
          _0: mode._0,
          _1: mode._1,
          _2: mapSelectingUrls(mapHtmlElement, mode._2)
        };
        break;
    case /* Exiting */5 :
        var match$1 = mode._0;
        tmp = {
          TAG: /* Exiting */5,
          _0: {
            didDetachListeners: match$1.didDetachListeners,
            nRemainingDebouncedTimeers: match$1.nRemainingDebouncedTimeers,
            allExitReasons: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                    return mapExitReason(mapHtmlElement, mapDomEvent, param);
                  }), match$1.allExitReasons)
          }
        };
        break;
    case /* Exited */6 :
        tmp = {
          TAG: /* Exited */6,
          _0: Curry._2(StateMachine$SmartcutsMacros.Exit.AllExitReasons.map, (function (param) {
                  return mapExitReason(mapHtmlElement, mapDomEvent, param);
                }), mode._0)
        };
        break;
    
  }
  return {
          mode: tmp,
          maybeDebounceManager: Belt_Option.map(param.maybeDebounceManager, (function (param) {
                  return StateMachine__DebounceManager$SmartcutsMacros.map(mapDomEvent, (function (param) {
                                
                              }), param);
                }))
        };
}

function mapSelectingUrls(mapHtmlElement, param) {
  return {
          urlPatterns: param.urlPatterns,
          page: param.page,
          links: $$Array.map((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                }), param.links),
          linkGroups: param.linkGroups,
          detachListeners: param.detachListeners,
          maybePaginateFn: OptionUtils$SmartcutsMacros.map(param.maybePaginateFn, (function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, param);
                })),
          triggeringLink: OptionUtils$SmartcutsMacros.map(param.triggeringLink, mapHtmlElement)
        };
}

function mapStateCallback(mapHtmlElement, callback) {
  if (callback.TAG === /* Cb_SelectingUrls */0) {
    return {
            TAG: /* Cb_SelectingUrls */0,
            _0: mapSelectingUrls(mapHtmlElement, callback._0)
          };
  } else {
    return {
            TAG: /* Cb_PlayingBackPageAction */1,
            _0: callback._0,
            _1: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, callback._1),
            _2: mapSelectingUrls(mapHtmlElement, callback._2)
          };
  }
}

function mapEvent(mapHtmlElement, mapDomEvent, $$event) {
  if (typeof $$event === "number") {
    switch ($$event) {
      case /* WindowResized */0 :
          return /* WindowResized */0;
      case /* DidBgStopRecordPageAction */1 :
          return /* DidBgStopRecordPageAction */1;
      case /* PaginationFnCompleted */2 :
          return /* PaginationFnCompleted */2;
      case /* PaginationFnFailed */3 :
          return /* PaginationFnFailed */3;
      case /* DidDetachListeners */4 :
          return /* DidDetachListeners */4;
      
    }
  } else {
    switch ($$event.TAG | 0) {
      case /* Initialize */0 :
          return {
                  TAG: /* Initialize */0,
                  _0: mapTriggeringElement(mapHtmlElement, $$event._0),
                  _1: $$event._1
                };
      case /* DidAttachListeners */1 :
          return {
                  TAG: /* DidAttachListeners */1,
                  _0: $$event._0
                };
      case /* QuerySelectorAllDidFindElements */2 :
          return {
                  TAG: /* QuerySelectorAllDidFindElements */2,
                  _0: Belt_Array.map($$event._0, mapHtmlElement)
                };
      case /* DidFinishGroupLinks */3 :
          return {
                  TAG: /* DidFinishGroupLinks */3,
                  _0: $$Array.map((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                        }), $$event._0),
                  _1: $$event._1
                };
      case /* LinkAtIndexUpdated */4 :
          return {
                  TAG: /* LinkAtIndexUpdated */4,
                  _0: MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, $$event._0),
                  _1: $$event._1
                };
      case /* LinksUpdated */5 :
          return {
                  TAG: /* LinksUpdated */5,
                  _0: $$Array.map((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                        }), $$event._0)
                };
      case /* DidSetTimer */6 :
          return {
                  TAG: /* DidSetTimer */6,
                  _0: $$event._0
                };
      case /* TimerFinished */7 :
          return {
                  TAG: /* TimerFinished */7,
                  _0: $$event._0,
                  _1: $$event._1
                };
      case /* PageActionRecordedAsClickElement */8 :
          return {
                  TAG: /* PageActionRecordedAsClickElement */8,
                  _0: Curry._1(mapHtmlElement, $$event._0)
                };
      case /* BasicEventWhileUrlTriggering */9 :
          return {
                  TAG: /* BasicEventWhileUrlTriggering */9,
                  _0: $$event._0
                };
      case /* DomEvent */10 :
          return {
                  TAG: /* DomEvent */10,
                  _0: Curry._1(mapDomEvent, $$event._0),
                  _1: $$event._1
                };
      case /* DidSetNewDebounceTimeout */11 :
          return {
                  TAG: /* DidSetNewDebounceTimeout */11,
                  _0: $$event._0,
                  _1: $$event._1
                };
      case /* DebounceTimerExpired */12 :
          return {
                  TAG: /* DebounceTimerExpired */12,
                  _0: $$event._0
                };
      case /* DidFlushDebouncedEvent */13 :
          return {
                  TAG: /* DidFlushDebouncedEvent */13,
                  _0: StateMachine__DebounceManager$SmartcutsMacros.mapEntry(mapDomEvent, (function (param) {
                          
                        }), $$event._0)
                };
      case /* DidClearDebounceTimeout */14 :
          return {
                  TAG: /* DidClearDebounceTimeout */14,
                  _0: $$event._0
                };
      case /* Fail */15 :
          return {
                  TAG: /* Fail */15,
                  _0: mapFailure(mapHtmlElement, mapDomEvent, $$event._0)
                };
      case /* Exit */16 :
          return {
                  TAG: /* Exit */16,
                  _0: mapExitReason(mapHtmlElement, mapDomEvent, $$event._0)
                };
      
    }
  }
}

function mapFailure(mapHtmlElement, mapDomEvent, failure) {
  return Curry._5(StateMachine$SmartcutsMacros.Failure.WithListener.map, (function (param) {
                return mapState(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapEvent(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect(mapHtmlElement, mapDomEvent, param);
              }), (function (listener) {
                return listener;
              }), failure);
}

function mapExitReason(mapHtmlElement, mapDomEvent, exitReason) {
  return Curry._5(StateMachine$SmartcutsMacros.Exit.ExitReason.WithListener.map, (function (param) {
                return mapState(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapEvent(mapHtmlElement, mapDomEvent, param);
              }), (function (param) {
                return mapSideEffect(mapHtmlElement, mapDomEvent, param);
              }), (function (listener) {
                return listener;
              }), exitReason);
}

function mapSideEffect(mapHtmlElement, mapDomEvent, sideEffect) {
  if (typeof sideEffect === "number") {
    switch (sideEffect) {
      case /* AttachListeners */0 :
          return /* AttachListeners */0;
      case /* SetupListenerForClickEvent */1 :
          return /* SetupListenerForClickEvent */1;
      case /* HideMarkers */2 :
          return /* HideMarkers */2;
      case /* TellBgDidFinishPlaybackPageAction */3 :
          return /* TellBgDidFinishPlaybackPageAction */3;
      case /* TellBgMaybeReadyToPlaybackPagination */4 :
          return /* TellBgMaybeReadyToPlaybackPagination */4;
      case /* RemoveMarkers */5 :
          return /* RemoveMarkers */5;
      case /* RenderPlaybackModal */6 :
          return /* RenderPlaybackModal */6;
      case /* RemovePlaybackModal */7 :
          return /* RemovePlaybackModal */7;
      
    }
  } else {
    switch (sideEffect.TAG | 0) {
      case /* RespondToBg */0 :
          return {
                  TAG: /* RespondToBg */0,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* Dispatch */1 :
          return {
                  TAG: /* Dispatch */1,
                  _0: mapEvent(mapHtmlElement, mapDomEvent, sideEffect._0)
                };
      case /* QuerySelectorAllForLinks */2 :
          return {
                  TAG: /* QuerySelectorAllForLinks */2,
                  _0: sideEffect._0
                };
      case /* Timer */3 :
          return {
                  TAG: /* Timer */3,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* AskBgToStopRecordPageAction */4 :
          return {
                  TAG: /* AskBgToStopRecordPageAction */4,
                  _0: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, sideEffect._0)
                };
      case /* RunPaginateFn */5 :
          return {
                  TAG: /* RunPaginateFn */5,
                  _0: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, sideEffect._0)
                };
      case /* ScrollToPageClick */6 :
          return {
                  TAG: /* ScrollToPageClick */6,
                  _0: MultiUrlTriggering__Shared$SmartcutsMacros.ClickTarget.map(mapHtmlElement, sideEffect._0)
                };
      case /* RenderMarkers */7 :
          return {
                  TAG: /* RenderMarkers */7,
                  _0: $$Array.map((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                        }), sideEffect._0)
                };
      case /* GroupLinks */8 :
          return {
                  TAG: /* GroupLinks */8,
                  _0: $$Array.map((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                        }), sideEffect._0),
                  _1: sideEffect._1,
                  _2: OptionUtils$SmartcutsMacros.map(sideEffect._2, mapHtmlElement)
                };
      case /* KillTimer */9 :
          return {
                  TAG: /* KillTimer */9,
                  _0: sideEffect._0
                };
      case /* TellBgToUpdateLinks */10 :
          return {
                  TAG: /* TellBgToUpdateLinks */10,
                  _0: $$Array.map((function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                        }), sideEffect._0)
                };
      case /* TellBgToUpdateLinkAtIndex */11 :
          return {
                  TAG: /* TellBgToUpdateLinkAtIndex */11,
                  _0: MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, sideEffect._0),
                  _1: sideEffect._1
                };
      case /* TellBgToUpdateLinkGroups */12 :
          return {
                  TAG: /* TellBgToUpdateLinkGroups */12,
                  _0: sideEffect._0
                };
      case /* TellBgToUpdatePaginateFn */13 :
          return {
                  TAG: /* TellBgToUpdatePaginateFn */13,
                  _0: MultiUrlTriggering__Shared$SmartcutsMacros.PaginateFnWithPolymorphicClickTargetRepresentation.map(mapHtmlElement, sideEffect._0)
                };
      case /* PrepareForScreenshotWithLinksAndRespond */14 :
          return {
                  TAG: /* PrepareForScreenshotWithLinksAndRespond */14,
                  _0: Belt_Array.map(sideEffect._0, (function (param) {
                          return MultiUrlTriggering__Shared$SmartcutsMacros.Link.mapLink(mapHtmlElement, param);
                        })),
                  _1: sideEffect._1
                };
      case /* ResetDebounceTimeout */15 :
          return {
                  TAG: /* ResetDebounceTimeout */15,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* ClearDebounceTimeout */16 :
          return {
                  TAG: /* ClearDebounceTimeout */16,
                  _0: sideEffect._0,
                  _1: sideEffect._1
                };
      case /* DetachListeners */17 :
          return {
                  TAG: /* DetachListeners */17,
                  _0: sideEffect._0
                };
      
    }
  }
}

var Generic = {
  mode_encode: mode_encode,
  mode_decode: mode_decode,
  exiting_encode: exiting_encode,
  exiting_decode: exiting_decode,
  state_encode: state_encode,
  state_decode: state_decode,
  awaitingNewLinks_encode: awaitingNewLinks_encode,
  awaitingNewLinks_decode: awaitingNewLinks_decode,
  stateCallback_encode: stateCallback_encode,
  stateCallback_decode: stateCallback_decode,
  initializing_encode: initializing_encode,
  initializing_decode: initializing_decode,
  triggeringElement_encode: triggeringElement_encode,
  triggeringElement_decode: triggeringElement_decode,
  selectingUrls_encode: selectingUrls_encode,
  selectingUrls_decode: selectingUrls_decode,
  event_encode: event_encode,
  event_decode: event_decode,
  failure_encode: failure_encode,
  failure_decode: failure_decode,
  exitReason_encode: exitReason_encode,
  exitReason_decode: exitReason_decode,
  errorContext_encode: errorContext_encode,
  errorContext_decode: errorContext_decode,
  otherFailureReason_encode: otherFailureReason_encode,
  otherFailureReason_decode: otherFailureReason_decode,
  listener_encode: listener_encode,
  listener_decode: listener_decode,
  sideEffect_encode: sideEffect_encode,
  sideEffect_decode: sideEffect_decode,
  stringifyListener: stringifyListener,
  stringifyStateCallback: stringifyStateCallback,
  stringifyTriggeringElement: stringifyTriggeringElement,
  stringifyInitializing: stringifyInitializing,
  stringifyMode: stringifyMode,
  stringifyState: stringifyState,
  stringifyEvent: stringifyEvent,
  stringifyFailure: stringifyFailure,
  stringifyOtherFailureReason: stringifyOtherFailureReason,
  stringifyExitReason: stringifyExitReason,
  stringifySideEffect: stringifySideEffect,
  mapTriggeringElement: mapTriggeringElement,
  mapInitializing: mapInitializing,
  mapState: mapState,
  mapSelectingUrls: mapSelectingUrls,
  mapStateCallback: mapStateCallback,
  mapEvent: mapEvent,
  mapFailure: mapFailure,
  mapExitReason: mapExitReason,
  mapSideEffect: mapSideEffect
};

var Regular = {};

var listener_encode$1 = listener_encode;

var listener_decode$1 = listener_decode;

function state_encode$1(v) {
  return state_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, DOM__Event__ForSerialization$SmartcutsMacros.t__encode, v);
}

function state_decode$1(v) {
  return state_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, DOM__Event__ForSerialization$SmartcutsMacros.t__decode, v);
}

var ForSerialization = {
  listener_encode: listener_encode$1,
  listener_decode: listener_decode$1,
  state_encode: state_encode$1,
  state_decode: state_decode$1
};

var Shared;

exports.Shared = Shared;
exports.timeoutId_encode = timeoutId_encode;
exports.timeoutId_decode = timeoutId_decode;
exports.Generic = Generic;
exports.Regular = Regular;
exports.ForSerialization = ForSerialization;
/* Util-SmartcutsMacros Not a pure module */
